var selectors = {
	wrapperSelector: '#recently-viewed-products'
};
selectors.limit = parseInt(jQuery(selectors.wrapperSelector).parent().data('limit'));

Shopify.Products.recordRecentlyViewed();
Shopify.Products.showRecentlyViewed({ 
	howManyToShow: 4,
	onComplete: function(evt){
		jQuery(selectors.wrapperSelector).parent().show();

      	jQuery('#recently-viewed-products .price-item--save').each(function(){
          var t = jQuery(this);
          var p = t.text();
          t.html(Shopify.formatMoney(p, window.myprice));
        });
      
      	jQuery('#recently-viewed-products span.price-item.save-price').each(function(){
          if($(this).is(':contains("-")')){
            $(this).hide();
          }
        });
      
        jQuery('#recently-viewed-products dd.price__compare').each(function(){
          if($(this).is(':contains("$0")')){
            $(this).hide();
          }
        });

        // Hide broken savings where compare_at_price is null
        jQuery('#recently-viewed-products span.price-item.save-price').each(function(){
          var text = $(this).text();
          if(text.indexOf('Infinity') !== -1 || text.indexOf('NaN') !== -1){
            $(this).hide();
          }
        });

        // Hide price__sale block entirely if no compare_at_price
        jQuery('#recently-viewed-products .price__sale').each(function(){
          var compareEl = $(this).find('.price-item--regular');
          if(compareEl.text().trim() === '$0.00' || compareEl.text().trim() === ''){
            $(this).find('dd.price__compare').hide();
          }
        });
	}
});